import "./Footer.css";
import { useNavigate } from "react-router-dom";
import ConditionsOfUseV2 from "./ConditionsOfUseV2";
import PolicyNoticeV2 from "./PolicyNoticeV2";
import AdsPrivacyChoices2 from "./AdsPrivacyChoices2";
function Footer() {
  return (
    <>
      <div className="footer">
        <div className="grid">
          <div className="box">
            <ConditionsOfUseV2 />
          </div>
          <div className="box">
            <PolicyNoticeV2 />
          </div>
          <div className="box">
            <AdsPrivacyChoices2 />
          </div>
          <div className="box">
            <span>
              &copy; {new Date().getFullYear()},
              {` ${process.env.REACT_APP_SITE_DOMAIN_NAME}`}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
export default Footer;
